import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Partners from './Partners';
import PartnersList from './PartnersList';
import PartnerSettings from './partnerSettings';
import PartnerImport from './import/partnerImport';
import PageError from '../error/pageError';

export default function PartnersRouter({ organization, path }) {
    return (
        <Switch>
            <Route exact path={`${path}/`} render={() => <PartnersList organization={organization} />} />
            <Route exact path={`${path}/settings`} render={() => <PartnerSettings organization={organization} />} />
            <Route exact path={`${path}/new`} render={() => <Partners organization={organization} />} />
            <Route exact path={`${path}/imports/new`} render={() => <PartnerImport organization={organization} />} />

            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

PartnersRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
